import { KeySequence } from '../keyboard-shortcuts.model';

export function areKeySequencesEqual(a: KeySequence, b: KeySequence) {
  return a.id === b.id && a.namespace === b.namespace;
}
